<ng-container
  *ngIf="{
    row: columnData | async
  } as $"
>
  <div
    *ngIf="$.row.recurring_services; else non_recurring"
    class="flex align-items-center"
  >
    <i class="fa fa-refresh mr-2"></i><span>Yes</span>
  </div>
  <ng-template #non_recurring>
    <div class="flex align-items-center">
      <i class="fa fa-ban mr-2"></i><span>No</span>
    </div>
  </ng-template>
</ng-container>
